/* RESPONSIBLE TEAM: team-inbox-experience */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'intercom_pages_settings';
  },
});
